import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Atoms/Buttons/ColorButtons.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Atoms/inputText.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Molecules/AvatarImage.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Cards/BusinessCard.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Cards/Social/SocialPostSmallCard.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Cards/TalentProfileAuthCard.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Forms/InquiryForm.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Nav/MainNavbar_2.js");
